import "../styles/main.css";

function Facilities() {
  return (
    <div className="facilities">

      <h2>Our Facilities</h2>
      <p className="subtitle">
        We provide a safe, modern, and supportive environment for students.
      </p>

      <div className="facility-grid">

        <div className="facility-card">
          <h3>🏫 Spacious Building</h3>
          <p>
            A well-structured and spacious campus providing a comfortable and 
            peaceful environment for learning.
          </p>
        </div>

        <div className="facility-card">
          <h3>👩‍🏫 Expert Professors</h3>
          <p>
            Highly qualified and experienced faculty dedicated to quality 
            teaching and student success.
          </p>
        </div>

        <div className="facility-card">
          <h3>🛡 Safe Environment</h3>
          <p>
            A secure and women-friendly campus ensuring safety, comfort, and 
            confidence for all students.
          </p>
        </div>

        <div className="facility-card">
          <h3>📚 Free Library</h3>
          <p>
            Well-equipped library with a wide range of books, journals, and 
            study materials.
          </p>
        </div>

        <div className="facility-card">
          <h3>💻 Computer Lab</h3>
          <p>
            Modern computer lab with updated systems and internet access for 
            practical learning.
          </p>
        </div>

        <div className="facility-card">
          <h3>🏀 Sports & Games</h3>
          <p>
            Updated facilities for indoor and outdoor games to promote 
            physical fitness and teamwork.
          </p>
        </div>

        <div className="facility-card">
          <h3>🎯 Competitive Guidance</h3>
          <p>
            Special guidance and support for competitive exams and career 
            opportunities.
          </p>
        </div>

        <div className="facility-card">
          <h3>🌟 Personality Development</h3>
          <p>
            Programs and activities to build confidence, communication skills, 
            and overall personality.
          </p>
        </div>

        <div className="facility-card">
          <h3>📹 CCTV Surveillance</h3>
          <p>
            Entire campus is under CCTV surveillance ensuring safety and 
            security at all times.
          </p>
        </div>

      </div>

    </div>
  );
}

export default Facilities;